<template>
  <div class="news-item-container">
    <div class="row news-item-container-title">
      <span class="news-item-container-title-left">
        <a v-if="!data.is_pdf" class="title" :href="data.url" target="_blank">{{data.title}}</a>
        <router-link @click.native="toPdfPage" class="title" v-else target="_blank" :to="{path: '/pdf-detail'}">
          <span>{{data.title}}</span>
        </router-link>
      </span>
      <div class="row date-source">
        <div class="date">{{data.date}}</div>
        <div class="source">{{data.source}}</div>
      </div>
    </div>
    <div class="summary" v-if="data.summary">
      <div class="summary-content">{{data.summary}}</div>
    </div>
    <div class="companies-industries-content" v-show="data.companies.length || data.industries.length">
      <div class="companies-industries">
        <div class="companies-data" @click="toCompanyDetail(item.name)" v-for="(item, index) in data.companies" :key="index">{{item.stock_code}}</div>
        <span v-for="(ii, index) in data.persons" :key="index+'persons'" @click="toPersonDetail(ii)" class="company-name">
          <div class="important-company-img"></div>
          <span>{{ii}}</span>
        </span>
        <div class="industries-data" v-for="(it, index) in data.industries" :key="index+'industries'">{{it}}</div>
      </div>
      <el-button v-if="showBtn" @click="onChangeBtnStatus" class="companies-industries-all-show-btn">
        <span v-if="!showAllTabs">展开</span>
        <img v-if="!showAllTabs" src="../../assets/img/down-arrow1.svg" class="companies-industries-all-show-btn-img icon" alt="">
        <span v-if="showAllTabs">收起</span>
        <img v-if="showAllTabs" src="../../assets/img/up-arrow1.svg" class="companies-industries-all-show-btn-img icon" alt="">
      </el-button>
    </div>
    <sn-news-dialog ref="snNewsDialog"></sn-news-dialog>

    <div class="news-dialog">
      <el-dialog
        :visible.sync="similarityDialogVisible"
        width="814px"
        >
        <div class="news-dialog_title">相关新闻<span class="news-dialog_title-count">({{similarityTotalCount}}条)</span></div>
        <div class="news-list-box">
          <similarity-news-list-item v-for="(item, idx) in similarityResultData" :data="item" :key="idx"></similarity-news-list-item>
          <div class="no-data-container" v-if="!similarityTotalCount">
            <no-data></no-data>
          </div>
        </div>  
      </el-dialog>
    </div>
  </div>
</template>

<script>
import QuestionQuery from '@/rest/questionQuery';
import SimilarityNewsListItem from '@/components/news-monitor/SimilarityNewsListItem';
import SnNewsDialog from '@/components/common/SnNewsDialog';
import localStorageHelper from '@/helpers/localStorageHelper';

export default {
  name: 'news-list-item',
  props: {
    data: {
      type: Object,
      required: true
    },
    index: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      showAllTabs: false,
      showBtn: false,
      companiesIndustriesElementHeight: 0,
      companiesIndustriesElement: null,
      similarityDialogVisible: false,
      similarityTotalCount: 0,
      similarityResultData: []
    };
  },
  methods: {
    toPdfPage() {
      localStorageHelper.setItem('PDF_DETAIL_DATA', JSON.stringify(this.data));
    },
    toPersonDetail(res) {
      const routeUrl = this.$router.resolve({
        path: '/person',
        query: {
          q: res
        }
      });
      window.open(routeUrl.href, '_blank');
    },
    onChangeBtnStatus() {
      this.showAllTabs = !this.showAllTabs;
      if (this.showAllTabs) {
        this.companiesIndustriesElement[this.index].style.height = `${this.companiesIndustriesElementHeight}px`;
        this.companiesIndustriesElement[this.index].style.overflow = 'auto';
        this.companiesIndustriesElement[this.index].style.transition = 'all .3s ease-in';
      } else {
        this.companiesIndustriesElement[this.index].style.height = '60px';
        this.companiesIndustriesElement[this.index].style.overflow = 'hidden';
        this.companiesIndustriesElement[this.index].style.transition = 'all .3s ease-in';
      }
    },
    toCompanyDetail(res) {
      const routeUrl = this.$router.resolve({
        path: '/result',
        query: {
          q: res
        }
      });
      window.open(routeUrl.href, '_blank');
    },
    onEmitNewsId(newsId) {
      this.similarityDialogVisible = true;
      QuestionQuery.similarityNewsList(newsId).then(result => {
        this.similarityTotalCount = result.totalCount;
        this.similarityResultData = result.pageItems;
      });
    }
  },
  components: {
    SimilarityNewsListItem,
    SnNewsDialog
  },
  mounted() {
    this.companiesIndustriesElement = Array.from(document.querySelectorAll('.companies-industries-content'));
    this.$nextTick(() => {
      this.companiesIndustriesElementHeight = this.companiesIndustriesElement[this.index].clientHeight;
      if (this.companiesIndustriesElementHeight > 60) {
        this.companiesIndustriesElement[this.index].style.height = '60px';
        this.companiesIndustriesElement[this.index].style.overflow = 'hidden';
        this.showBtn = true;
        this.showAllTabs = false;
      } else {
        this.showBtn = false;
      }
    });
  }
};
</script>

<style lang="scss" scoped>
.icon {
  width: 16px;
}
.news-item-container {
  padding: 16px 0 6px;
  box-shadow: inset 0px -1px 0px 0px #f7f7fa;
  .news-item-container-title {
    justify-content: space-between;
    margin-bottom: 12px;
    line-height: 22px;
    .news-item-container-title-left {
      width: 750px;
    }
    .title {
      display: inline-block;
      margin-right: 16px;
      min-height: 22px;
      color: #171f46;
      font-size: 16px;
      font-weight: 500;
      text-decoration: none;
      cursor: pointer;
      &:hover {
        text-decoration: underline;
      }
    }
    .related-news-icon {
      display: inline-block;
      width: 16px;
      height: 16px;
      margin-right: 2px;
      vertical-align: middle;
      background-image: url('../../assets/img/related-news.svg');
      background-size: cover;
    }
    .related-news {
      font-size: 12px;
      color: #45a8cc;
      cursor: pointer;
      &:hover {
        color: #3cbeed;
        font-weight: bold;
      }
      &:active {
        color: #45a8cc;
        font-weight: bold;
      }
    }
    .date-source {
      margin-left: 20px;
      color: #747990;
      font-size: 12px;
      .source {
        margin-left: 16px;
        max-width: 108px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
  }
  .summary {
    margin-bottom: 12px;
    .summary-content {
      word-break: break-all;
      color: #747990;
      font-size: 13px;
      letter-spacing: 0.3px;
    }
  }
  .companies-industries-content {
    display: flex;
    margin-top: 10px;
    .companies-industries-all-show-btn {
      margin-top: 30px;
      margin-left: 28px;
      height: 20px;
      line-height: 20px;
      width: 60px;
      padding: 0;
      border-radius: 2px;
      border: none;
      font-size: 12px;
      color: #464d6c;
      background-color: #f7f8fc;
      font-weight: 400;
      &:hover {
        color: #464d6c;
        background-color: #eaebef;
      }
      &:focus {
        color: #464d6c;
        background-color: #eaebef;
      }
      &:active {
        color: #464d6c;
        background-color: #eaebef;
      }
      &-img {
        margin-bottom: -4px;
      }
    }
    .companies-industries {
      display: flex;
      flex-wrap: wrap;
      width: 1060px;
      .companies-data {
        margin-right: 10px;
        margin-bottom: 10px;
        height: 20px;
        line-height: 20px;
        padding: 0 8px;
        border-radius: 2px;
        color: #464d6c;
        font-size: 12px;
        background: #f7f8fc;
        cursor: pointer;
        &:hover {
          background-image: linear-gradient(rgba(0, 0, 0, 0.05), rgba(0, 0, 0, 0.05)), linear-gradient(#f7f8fc, #f7f8fc);
          background-blend-mode: normal, normal;
        }
      }
      .industries-data {
        margin-right: 10px;
        margin-bottom: 10px;
        padding: 0 8px;
        height: 20px;
        border: 1px solid #e8e8e8;
        border-radius: 2px;
        line-height: 20px;
        color: #464d6c;
        font-size: 12px;
      }
      .company-name {
        position: relative;
        z-index: 1;
        display: inline-block;
        margin-right: 10px;
        margin-bottom: 10px;
        height: 20px;
        line-height: 20px;
        padding: 0px 8px;
        border-radius: 2px;
        background: #f7f8fc;
        color: #464d6c;
        font-size: 12px;
        cursor: pointer;
        &:hover {
          background-image: linear-gradient(rgba(0, 0, 0, 0.05), rgba(0, 0, 0, 0.05)), linear-gradient(#f7f8fc, #f7f8fc);
          background-blend-mode: normal, normal;
        }
        .important-company-img {
          display: inline-block;
          margin-bottom: -3px;
          margin-right: 5px;
          width: 16px;
          height: 16px;
          line-height: 16px;
          background: url('../../assets/img/person-icon.svg') no-repeat;
          background-size: cover;
        }
      }
    }
  }
  .tag-name {
    margin-right: 10px;
    font-size: 12px;
  }
  .positive {
    color: #ff5b65;
  }
  .negative {
    color: #54cea4;
  }
  .neutral {
    color: #ffffff;
  }
}
/deep/.detail-dialog {
  .detail-dialog-header {
    padding: 32px 32px 24px;
    min-height: 110px;
    width: 100%;
    box-shadow: inset 0px -1px 0px 0px#4f4e55;
    .title {
      margin-bottom: 10px;
      color: #ffffff;
      font-size: 20px;
      font-weight: 500;
    }
    .dialog-date-source {
      justify-content: space-between;
      color: rgba(255, 255, 255, 0.7);
      font-size: 12px;
      font-weight: 500;
      .source {
        margin-left: 16px;
      }
    }
  }
  .detail-dialog-content {
    padding: 24px 32px;
    height: 496px;
    overflow: auto;
    color: #ffffff;
    font-size: 14px;
    line-height: 22px;
    box-shadow: inset 0px -1px 0px 0px#4f4e55;
  }
  .detail-dialog-footer {
    padding: 16px 32px;
    .url {
      color: #45a8cc;
      font-size: 14px;
      font-weight: 500;
      text-decoration: none;
    }
    .warning {
      margin-top: 4px;
      color: rgba(255, 255, 255, 0.7);
      font-size: 12px;
    }
  }
  .el-dialog {
    background-color: #333138;
    .el-dialog__header {
      padding: 0;
    }
    .el-dialog__body {
      min-height: 680px;
      padding: 0;
    }
    .el-dialog__footer {
      padding: 0px;
    }
  }
}
/deep/ {
  .el-switch__core {
    width: 34px !important;
  }
  .el-switch__core:after {
    top: 3px;
    left: 3px;
    width: 12px;
    height: 12px;
    background-color: #e4e4e4;
  }
  .el-switch.is-checked .el-switch__core::after {
    margin-left: -14px;
  }
}

.news-dialog {
  &_title {
    height: 44px;
    line-height: 44px;
    padding-left: 24px;
    font-size: 14px;
    color: #171f46;
    box-shadow: 0px 1px 0px 0px rgba(247, 247, 250, 1);
  }
  .news-list-box {
    height: 656px;
    overflow-y: auto;
    .no-data-container {
      height: 500px;
    }
  }
  /deep/ .el-dialog__wrapper {
    background: rgba(0, 0, 0, 0.4);
    .el-dialog {
      width: 900px;
      position: relative;
      margin-top: 13vh !important;
      border-radius: 8px;
      border: solid 1px #3e393b;
      .el-dialog__header {
        position: absolute;
        top: 0;
        right: 0px;
        .el-dialog__headerbtn {
          width: 24px;
          height: 24px;
          top: 12px;
          .el-dialog__close {
            color: #514d4f;
          }
        }
      }
      .el-dialog__body {
        background: #ffffff;
        padding: 0;
        .search-news-list-container {
          .filter {
            height: 54px;
            justify-content: center;
            span {
              display: none;
            }
            div {
              display: none;
            }
            border-bottom: 1px solid #4e4a4d;
            padding-bottom: 22px;
          }
          .result-container {
            height: 60vh;
            overflow-y: auto;
            margin-top: 0;
            .news-list-header {
              display: none;
            }
          }
        }
      }
    }
  }
}
</style>
